import { useDashboard } from "../layouts/Dashboard/useDashboard";
export const useMaxHeight = () => {
    let { widgets, tab } = useDashboard();
    let h_lg = 0;
    let h_sm = 0;
    widgets.filter(a => a.tab === tab).forEach((i) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (((_a = i.layouts.lg) === null || _a === void 0 ? void 0 : _a.y) + ((_b = i.layouts.lg) === null || _b === void 0 ? void 0 : _b.h) > h_lg) {
            h_lg = ((_c = i.layouts.lg) === null || _c === void 0 ? void 0 : _c.y) + ((_d = i.layouts.lg) === null || _d === void 0 ? void 0 : _d.h);
        }
        if (((_e = i.layouts.sm) === null || _e === void 0 ? void 0 : _e.y) + ((_f = i.layouts.sm) === null || _f === void 0 ? void 0 : _f.h) > h_sm) {
            h_sm = ((_g = i.layouts.sm) === null || _g === void 0 ? void 0 : _g.y) + ((_h = i.layouts.sm) === null || _h === void 0 ? void 0 : _h.h);
        }
    });
    return { lg: h_lg, sm: h_sm };
};
//# sourceMappingURL=useMaxHeight.js.map